"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invariant = void 0;
/**
 * Throw an error if the condition fails
 */
function invariant(condition, message = 'no reason specified', ErrorClass = Error) {
    if (!condition) {
        throw new ErrorClass(`Invariant failed: ${message}`);
    }
}
exports.invariant = invariant;
//# sourceMappingURL=invariant.js.map